import { FormattedMessage } from 'react-intl'
import { Text } from 'src/Components'
import {
  ListingSourceInfo,
  useComplianceData,
} from 'src/services/mlsComplianceDataService'
import { ListingDetailsListing } from 'src/types/listings'

type ListingWithMlsNumber = Pick<ListingDetailsListing, 'mlsNumber'>

interface DataProvidedByMlsAbbrevNumberProps {
  listing: ListingSourceInfo & ListingWithMlsNumber
  className?: string
}

export const DataProvidedByMlsAbbrevAndNumber = ({
  listing,
  className,
}: DataProvidedByMlsAbbrevNumberProps) => {
  const complianceData = useComplianceData(listing)

  if (!complianceData?.mlsAbbreviation) {
    return null
  }

  return (
    <Text
      data-qa='dataProvidedByText'
      element='span'
      size='tiny'
      variant='neutralCool'
      variantCount='500'
      className={className}
    >
      <FormattedMessage
        id='HomeSearch.listingDetails.nmls.dataProvidedByMlsAbrvAndNumber'
        defaultMessage='Data provided by {mlsAbrv} #{mlsNumber}'
        values={{
          mlsAbrv: complianceData?.mlsAbbreviation,
          mlsNumber: listing?.mlsNumber,
        }}
      />
    </Text>
  )
}
